"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as React from "react";
import { createPortal } from "react-dom";
import classNames from "classnames";
import { observer, Observer } from "mobx-react";
import { Transition } from "react-transition-group";
import { debounce } from "lodash";
import { SearchInput, Spinner } from "../../..";
import { TextInputSize, TextInputTheme, TextInputVariant } from "../TextInput/TextInput";
import { action, observable } from "mobx";
import { randomString, KeyType, MouseButtonType, Layer } from "../../../utils";
import { AnimationDuration } from "../../../styles/Animations";
import Panel, { PanelTheme } from "../panel/Panel/Panel";
import getPortalRoot from "../../../utils/getPortalRoot";
import observeRect from "@reach/observe-rect";
import getOverlayPosition from "../../../utils/getOverlayPosition";
import forceReflow from "../../../utils/forceReflow";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
export var RemoteDataStatus = /* @__PURE__ */ ((RemoteDataStatus2) => {
  RemoteDataStatus2["NotRequested"] = "notRequested";
  RemoteDataStatus2["Loading"] = "loading";
  RemoteDataStatus2["Success"] = "success";
  RemoteDataStatus2["Error"] = "error";
  return RemoteDataStatus2;
})(RemoteDataStatus || {});
let Combobox = class extends React.Component {
  constructor(props) {
    var _a;
    super(props);
    this.selectedValue = null;
    this.selectedElemRef = React.createRef();
    this.isFocused = false;
    this.inputWidth = 0;
    this.textInputRef = React.createRef();
    this.entries = { status: "notRequested" /* NotRequested */ };
    this.getIdForEntry = (entryValue) => {
      return `comboboxentry${entryValue.toLowerCase().replace(/[^a-z0-9]/, "")}`;
    };
    this.setInputWidth = () => {
      var _a;
      this.inputWidth = ((_a = this.textInputRef.current) == null ? void 0 : _a.getBoundingClientRect().width) || 0;
    };
    this.handleSelect = (entry) => {
      this.props.onSelect(entry);
      if (this.props.clearOnSelect) {
        this.searchTerm = "";
        this.displayOnlyTerm = "";
        this.selectedValue = null;
      }
    };
    this.onKeyDown = (event) => {
      var _a, _b, _c, _d;
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      switch (event.key) {
        case KeyType.ArrowDown:
          const nextItem = this.getNextItem();
          if (nextItem) {
            this.selectedValue = nextItem.value;
            this.displayOnlyTerm = nextItem.label;
            setTimeout(() => {
              var _a2;
              (_a2 = this.selectedElemRef.current) == null ? void 0 : _a2.scrollIntoView({
                block: "center"
              });
            });
          }
          event.preventDefault();
          break;
        case KeyType.ArrowUp:
          const previousItem = this.getPreviousItem();
          if (previousItem) {
            this.selectedValue = previousItem.value;
            this.displayOnlyTerm = previousItem.label;
            setTimeout(() => {
              var _a2;
              (_a2 = this.selectedElemRef.current) == null ? void 0 : _a2.scrollIntoView({
                block: "center"
              });
            });
          }
          event.preventDefault();
          break;
        case KeyType.Enter:
          if (this.entries.status !== "success" /* Success */) {
            return;
          }
          const index = this.entries.data.findIndex((entry) => {
            if (this.selectedValue) {
              return entry.value === this.selectedValue;
            }
            return entry.label === (this.displayOnlyTerm || this.searchTerm);
          });
          if (index >= 0) {
            this.handleSelect(this.entries.data[index]);
          }
          (_a = this.textInputRef.current) == null ? void 0 : _a.blur();
          event.preventDefault();
          break;
        case KeyType.Escape:
          event.preventDefault();
          (_b = this.textInputRef.current) == null ? void 0 : _b.blur();
          (_d = (_c = this.props).onCancel) == null ? void 0 : _d.call(_c);
          break;
      }
    };
    this.getNextItem = () => {
      if (this.entries.status !== "success" /* Success */) {
        return null;
      }
      const index = this.entries.data.findIndex((entry) => {
        return entry.value === this.selectedValue;
      });
      if (index + 1 >= this.entries.data.length) {
        return this.entries.data[0];
      } else {
        return this.entries.data[index + 1];
      }
    };
    this.getPreviousItem = () => {
      if (this.entries.status !== "success" /* Success */) {
        return null;
      }
      const index = this.entries.data.findIndex((entry) => {
        return entry.value === this.selectedValue;
      });
      if (index - 1 < 0) {
        return this.entries.data[this.entries.data.length - 1];
      } else {
        return this.entries.data[index - 1];
      }
    };
    this.onFocus = () => {
      this.filterEntries();
      this.isFocused = true;
    };
    this.onBlur = () => {
      this.isFocused = false;
    };
    this.filterEntries = () => {
      if (this.props.entries instanceof Function) {
        this.setEntries({ status: "loading" /* Loading */ });
        this.debouncedFetchEntries(this.props.entries);
      } else {
        this.setEntries({
          status: "success" /* Success */,
          data: this.props.entries.filter((entry) => {
            if (!!this.props.onFilter) {
              return this.props.onFilter(entry, this.searchTerm);
            } else if (this.searchTerm === "") {
              return true;
            } else {
              return entry.label.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0;
            }
          })
        });
      }
    };
    this.fetchEntries = (fetch) => __async(this, null, function* () {
      const result = fetch(this.searchTerm);
      let entries;
      if (result instanceof Promise) {
        try {
          entries = yield result;
        } catch (e) {
          this.setEntries({
            status: "error" /* Error */,
            error: new Error("Something went wrong. Please try again.")
          });
          return;
        }
      } else {
        entries = result;
      }
      this.setEntries({
        status: "success" /* Success */,
        data: entries
      });
    });
    this.debouncedFetchEntries = debounce(this.fetchEntries, 500);
    this.searchTerm = (_a = props.startingSearchTerm) != null ? _a : "";
    this.comboListDomId = `combobox${randomString().toLowerCase()}`;
  }
  componentDidMount() {
    this.setInputWidth();
    let isShowing = false;
    if (this.props.autoFocus) {
      isShowing = true;
      setTimeout(() => {
        if (this.textInputRef.current != null) {
          this.textInputRef.current.focus();
        }
      });
    }
    if (this.props.autoSelect) {
      isShowing = true;
      setTimeout(() => {
        if (this.textInputRef.current != null) {
          this.textInputRef.current.select();
        }
      });
    }
    if (isShowing) {
      this.filterEntries();
    }
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      ComboboxWrapper,
      {
        className: classNames("combobox", `combobox--${this.props.theme}`),
        useWrapper: !this.props.renderInput
      },
      /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, onResize: this.setInputWidth }, this.renderComboboxInput()),
      /* @__PURE__ */ React.createElement(
        Transition,
        {
          mountOnEnter: true,
          unmountOnExit: true,
          in: this.isFocused,
          timeout: AnimationDuration.Long,
          onEnter: forceReflow
        },
        (status) => /* @__PURE__ */ React.createElement(Observer, null, () => {
          var _a;
          return /* @__PURE__ */ React.createElement(
            ComboboxListBox,
            {
              noEntriesMessage: this.searchTerm.length > 0 ? this.props.noResultsMessage : this.props.noEntriesMessage,
              entries: this.entries,
              handleSelect: this.handleSelect,
              getIdForEntry: this.getIdForEntry,
              textInputRef: this.textInputRef,
              selectedElemRef: this.selectedElemRef,
              selectedValue: this.selectedValue,
              theme: this.props.theme,
              renderEntry: this.props.renderEntry,
              isFocused: this.isFocused,
              comboListDomId: this.comboListDomId,
              className: this.props.className,
              transitionStatus: status,
              listWidth: this.inputWidth,
              listEndElement: this.props.listEndElement,
              autoStack: (_a = this.props.autoStack) != null ? _a : false
            }
          );
        })
      )
    );
  }
  renderComboboxInput() {
    const commonInputProps = {
      placeholder: this.props.placeholder,
      value: this.displayOnlyTerm || this.searchTerm,
      ref: this.textInputRef,
      role: "combobox",
      "aria-expanded": this.isFocused ? "true" : "false",
      "aria-required": "true",
      "aria-activedescendant": this.isFocused && this.selectedValue ? this.getIdForEntry(this.selectedValue) : void 0,
      "aria-controls": this.isFocused ? this.comboListDomId : void 0,
      "aria-autocomplete": "list",
      onChange: (value) => {
        this.searchTerm = value;
        this.displayOnlyTerm = "";
        this.selectedValue = null;
        this.filterEntries();
        if (this.props.onChange) {
          this.props.onChange(this.searchTerm);
        }
      },
      onKeyDown: this.onKeyDown,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    };
    if (!!this.props.renderInput) {
      return this.props.renderInput(commonInputProps);
    } else {
      return /* @__PURE__ */ React.createElement(
        SearchInput,
        __spreadProps(__spreadValues({}, commonInputProps), {
          label: this.props.label,
          theme: this.props.theme || TextInputTheme.Dark,
          variant: this.props.variant,
          size: this.props.size,
          startElement: this.props.startElement,
          endElement: this.props.endElement
        })
      );
    }
  }
  setEntries(entries) {
    this.entries = entries;
  }
};
Combobox.defaultProps = {
  autoFocus: false,
  autoSelect: false,
  clearOnSelect: false,
  noEntriesMessage: "No items available",
  noResultsMessage: "No results found",
  variant: TextInputVariant.Bordered,
  size: TextInputSize.Medium,
  theme: TextInputTheme.Light
};
__decorateClass([
  observable.ref
], Combobox.prototype, "searchTerm", 2);
__decorateClass([
  observable.ref
], Combobox.prototype, "displayOnlyTerm", 2);
__decorateClass([
  observable.ref
], Combobox.prototype, "selectedValue", 2);
__decorateClass([
  observable.ref
], Combobox.prototype, "isFocused", 2);
__decorateClass([
  observable.ref
], Combobox.prototype, "inputWidth", 2);
__decorateClass([
  observable.ref
], Combobox.prototype, "entries", 2);
__decorateClass([
  action
], Combobox.prototype, "setInputWidth", 2);
__decorateClass([
  action
], Combobox.prototype, "onFocus", 2);
__decorateClass([
  action
], Combobox.prototype, "onBlur", 2);
__decorateClass([
  action
], Combobox.prototype, "setEntries", 1);
Combobox = __decorateClass([
  observer
], Combobox);
export {
  Combobox as default
};
const ComboboxWrapper = (props) => {
  const { className, useWrapper, children } = props;
  if (useWrapper) {
    return /* @__PURE__ */ React.createElement("div", { className }, children);
  } else {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
};
let ComboboxListBox = class extends React.Component {
  constructor() {
    super(...arguments);
    this.portalRoot = getPortalRoot("combobox-root");
    this.listRef = React.createRef();
    this.handleRectObserver = (targetRect) => {
      var _a;
      const listRect = (_a = this.listRef.current) == null ? void 0 : _a.getBoundingClientRect();
      this.listPosition = getOverlayPosition({
        targetRect,
        overlayRect: listRect,
        position: "bottom",
        offset: 8,
        outerMargin: 8
      });
    };
    this.renderEntry = (entry) => {
      if (this.props.renderEntry != null) {
        return this.props.renderEntry(entry);
      } else {
        return /* @__PURE__ */ React.createElement(
          "span",
          {
            className: classNames("combobox__default-entry-label", `combobox__default-entry-label--${this.props.theme}`)
          },
          entry.label
        );
      }
    };
    this.renderPanelContent = () => {
      switch (this.props.entries.status) {
        case "notRequested" /* NotRequested */:
        case "loading" /* Loading */:
          return /* @__PURE__ */ React.createElement(Spinner, { className: "space-inset-l", primary: true });
        case "error" /* Error */:
          return /* @__PURE__ */ React.createElement("div", { className: "combobox__message" }, this.props.entries.error.message);
        case "success" /* Success */:
          return this.renderList(this.props.entries.data);
        default:
          throw new Error("Unknown Combobox Entries status");
      }
    };
  }
  componentDidMount() {
    var _a;
    this.rectObserver = observeRect(this.props.textInputRef.current, this.handleRectObserver);
    (_a = this.rectObserver) == null ? void 0 : _a.observe();
  }
  componentDidUpdate(prevProps) {
    if (this.props.textInputRef.current && prevProps.listWidth !== this.props.listWidth) {
      this.handleRectObserver(this.props.textInputRef.current.getBoundingClientRect());
    }
  }
  componentWillUnmount() {
    var _a;
    (_a = this.rectObserver) == null ? void 0 : _a.unobserve();
  }
  renderList(entries) {
    if (entries.length < 1) {
      return /* @__PURE__ */ React.createElement("div", { className: "combobox__message" }, this.props.noEntriesMessage);
    }
    return entries.map((entry) => {
      const isSelected = entry.value === this.props.selectedValue;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          id: this.props.getIdForEntry(entry.value),
          key: entry.value,
          className: classNames("combobox__entry", `combobox-entry--${this.props.theme}`, {
            "combobox__entry--selected": isSelected
          }),
          "aria-selected": isSelected ? "true" : "false",
          role: "option",
          ref: isSelected ? this.props.selectedElemRef : null,
          onMouseDown: (e) => {
            e.stopPropagation();
            e.nativeEvent.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            if (e.button === MouseButtonType.Left) {
              this.props.handleSelect(entry);
            }
          }
        },
        this.renderEntry(entry)
      );
    });
  }
  render() {
    return createPortal(
      /* @__PURE__ */ React.createElement(Layer, null, ({ zIndex }) => {
        var _a, _b;
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            ref: this.listRef,
            className: classNames("combobox__combo-holder", this.props.className),
            style: {
              transform: `translate3d(${((_a = this.listPosition) == null ? void 0 : _a.overlay.left) || 0}px, ${((_b = this.listPosition) == null ? void 0 : _b.overlay.top) || 0}px, 0)`,
              width: this.props.listWidth,
              zIndex: this.props.autoStack ? zIndex : void 0
            },
            onMouseDown: (e) => {
              e.nativeEvent.stopImmediatePropagation();
            }
          },
          /* @__PURE__ */ React.createElement(
            Panel,
            {
              className: classNames("combobox__combo", `combobox__combo--${this.props.transitionStatus}`),
              id: this.props.comboListDomId,
              role: "listbox",
              theme: this.props.theme === TextInputTheme.Dark ? PanelTheme.Dark : PanelTheme.Light
            },
            /* @__PURE__ */ React.createElement("div", { className: classNames("combobox__combo-content", `combobox__combo-content--${this.props.theme}`) }, this.renderPanelContent()),
            this.props.listEndElement
          )
        );
      }),
      this.portalRoot
    );
  }
};
__decorateClass([
  observable.ref
], ComboboxListBox.prototype, "listPosition", 2);
__decorateClass([
  action
], ComboboxListBox.prototype, "handleRectObserver", 2);
ComboboxListBox = __decorateClass([
  observer
], ComboboxListBox);
